var exports = {
  "x6": "SettingsHeadingLinkButton.module__button___bnU4ZT",
  "x2": "SettingsHeadingLinkButton.module__buttonCopied___bnU4ZT",
  "Kk": "SettingsHeadingLinkButton.module__icon___bnU4ZT",
};

module.exports = exports;
